import { Auth } from 'aws-amplify'
import axios from '../../config/axios.config'
import { axiosHeaders } from '../../utils'
import Swal from 'sweetalert2'

export const validateUserSession = async () => {
  const userSub = sessionStorage.getItem('userSub')

  const activeSessionId = sessionStorage.getItem('userTokenSessionId')

  try {
    const response: any = await axios.get('user/validate', {
      ...axiosHeaders(),
      params: {
        userSub,
        activeSessionId
      }
    })

    if (response.status !== 200 || !response.data.response.isValidUser) {
      modalSignOut()

      return false
    }

    return true
  } catch (error) {
    signOutUser()
  }
}

export const saveUserSession = async ({
  userSub,
  activeSessionId,
  issuedAt,
  expiresAt
}: {
  userSub: string
  activeSessionId: string
  issuedAt: string | number
  expiresAt: string | number
}) => {
  const postParams = {
    userSub,
    activeSessionId,
    issuedAt,
    expiresAt
  }

  try {
    await axios.post('user/save', postParams, axiosHeaders())
  } catch (error) {
    signOutUser()
  }
}

async function signOutUser() {
  sessionStorage.removeItem('auth-token')
  sessionStorage.removeItem('refresh-token')
  sessionStorage.removeItem('groups')
  sessionStorage.removeItem('userSub')
  sessionStorage.removeItem('userTokenSessionId')

  Auth.signOut().then(() => {
    Auth.federatedSignIn()
  })
}

function modalSignOut() {
  Swal.fire({
    title: 'Warning!',
    text: 'We detected another active session with your account. For your security, you have been signed out.',
    icon: 'warning',
    showConfirmButton: false,
    allowEscapeKey: false,
    timer: 3000
  }).then(() => {
    signOutUser()
  })
}
